module.exports = __webpack_public_path__ + "static/media/1.9e5fbeb3.png";